/* eslint-disable */
// @ts-nocheck

/**
 * This file is a generated Typescript file for GRPC Gateway, DO NOT MODIFY
 */

import * as GoogleProtobufEmpty from '../../../google/protobuf/empty.pb';
import * as GoogleProtobufTimestamp from '../../../google/protobuf/timestamp.pb';
import * as fm from '@generated/fetch.pb';

export type GetTeacherFeedbackV2WithFilterRequest = {
    year?: number;
    weekStartDate?: string;
    weekEndDate?: string;
    format?: string;
};

export type GetTeacherFeedbackV2WithFilterResponse = {
    feedbacks?: TeacherFeedbackV2WithSessionTime[];
    csvData?: Uint8Array;
};

export type SkillDescriptor = {
    skillQuestion?: string;
    skillAnswer?: string;
};

export type TeacherFeedbackV2WithSessionTime = {
    courseId?: string;
    sessionId?: string;
    roomId?: string;
    teacherId?: string;
    studentId?: string;
    attendance?: boolean;
    positiveStandout?: string;
    comfortLevelId?: number;
    participationLevelId?: number;
    questionIds?: number[];
    answerIds?: number[];
    flagIds?: number[];
    skillDescriptors?: SkillDescriptor[];
    remark?: string;
    sessionStartTime?: GoogleProtobufTimestamp.Timestamp;
};

export type V2GetFeedbackAnswersResponse = {
    answers?: V2Answer[];
};

export type V2Answer = {
    id?: number;
    value?: string;
};

export type V2GetFeedbackQuestionsResponse = {
    questions?: V2Question[];
};

export type V2Question = {
    id?: number;
    value?: string;
};

export type V2GetTeacherFeedbackDetailsRequest = {
    sessionId?: string;
    withString?: boolean;
};

export type V2GetTeacherFeedbackDetailsResponse = {
    levelFeedbacks?: V2LevelFeedback[];
};

export type V2LevelFeedback = {
    level?: V2LevelInfo;
    feedbacks?: V2Feedback[];
};

export type V2ChoiceMapping = {
    questionId?: number;
    answerChoiceIds?: number[];
};

export type V2LevelInfo = {
    name?: string;
    objective?: string;
    questionIds?: number[];
    choiceMappings?: V2ChoiceMapping[];
};

export type V2Feedback = {
    student?: V2Student;
    comfortLevelId?: number;
    participationLevelId?: number;
    positiveStandout?: string;
    answerIds?: number[];
    flagIds?: number[];
    remark?: string;
    comfortLevel?: string;
    participationLevel?: string;
    flags?: string[];
    attendanceInfo?: V2AttendanceInfo;
    mathWorksheetPagesCompleted?: number;
    mathWorksheetLastPage?: number | null;
    mathWorksheetSetNumber?: number | null;
    isCheckpointWorksheet?: boolean;
};

export type V2AttendanceInfo = {
    attendance?: boolean;
    punctuality?: boolean;
};

export type V2Student = {
    id?: string;
    fullName?: string;
    nickname?: string;
    partnerName?: string;
    mathLevel?: string;
};

export type V2GetComfortParticipationLevelsResponse = {
    comfortLevels?: ComfortLevel[];
    participationLevels?: ParticipationLevel[];
};

export type ComfortLevel = {
    id?: number;
    name?: string;
    participationLevelIds?: number[];
};

export type ParticipationLevel = {
    id?: number;
    name?: string;
};

export type V2GetFeedbackFlagResponse = {
    feedbackFlags?: FeedbackFlag[];
};

export type FeedbackFlag = {
    id?: number;
    feedback?: string;
};

export type V2TeacherFeedbackRecord = {
    studentId?: string;
    /** @deprecated This field has been deprecated. */
    attendance?: boolean;
    comfortLevelId?: number;
    participationLevelId?: number;
    positiveStandout?: string;
    questionIds?: number[];
    answerIds?: number[];
    flagIds?: number[];
    remark?: string;
    attendanceInfo?: V2AttendanceInfo;
    mathWorksheetPagesCompleted?: number;
    mathWorksheetLastPage?: number | null;
    mathWorksheetSetNumber?: number | null;
    isCheckpointWorksheet?: boolean;
};

export type V2PostTeacherFeedbackDetailsRequest = {
    sessionId?: string;
    requester?: string;
    feedbacks?: V2TeacherFeedbackRecord[];
};

export type MathLevelsResponse = {
    levels?: MathLevelOption[];
};

export type MathLevelOption = {
    value?: string;
    label?: string;
};

export class TeacherFeedbackV2 {
    static GetV2FeedbackAnswers(
        this: void,
        req: GoogleProtobufEmpty.Empty,
        initReq?: fm.InitReq
    ): Promise<V2GetFeedbackAnswersResponse> {
        return fm.fetchRequest<V2GetFeedbackAnswersResponse>(
            `/v2/feedback/answers?${fm.renderURLSearchParams(req, [])}`,
            { ...initReq, method: 'GET' }
        );
    }
    static GetV2FeedbackQuestions(
        this: void,
        req: GoogleProtobufEmpty.Empty,
        initReq?: fm.InitReq
    ): Promise<V2GetFeedbackQuestionsResponse> {
        return fm.fetchRequest<V2GetFeedbackQuestionsResponse>(
            `/v2/feedback/questions?${fm.renderURLSearchParams(req, [])}`,
            { ...initReq, method: 'GET' }
        );
    }
    static GetV2FeedbackFlags(
        this: void,
        req: GoogleProtobufEmpty.Empty,
        initReq?: fm.InitReq
    ): Promise<V2GetFeedbackFlagResponse> {
        return fm.fetchRequest<V2GetFeedbackFlagResponse>(
            `/v2/feedback/feedbackFlags?${fm.renderURLSearchParams(req, [])}`,
            { ...initReq, method: 'GET' }
        );
    }
    static GetV2FeedbackComfortParticipationLevels(
        this: void,
        req: GoogleProtobufEmpty.Empty,
        initReq?: fm.InitReq
    ): Promise<V2GetComfortParticipationLevelsResponse> {
        return fm.fetchRequest<V2GetComfortParticipationLevelsResponse>(
            `/v2/feedback/comfortParticipationLevels?${fm.renderURLSearchParams(
                req,
                []
            )}`,
            { ...initReq, method: 'GET' }
        );
    }
    static GetV2FeedbackDetails(
        this: void,
        req: V2GetTeacherFeedbackDetailsRequest,
        initReq?: fm.InitReq
    ): Promise<V2GetTeacherFeedbackDetailsResponse> {
        return fm.fetchRequest<V2GetTeacherFeedbackDetailsResponse>(
            `/v2/feedback/sessions/${
                req.sessionId
            }/details?${fm.renderURLSearchParams(req, ['sessionId'])}`,
            { ...initReq, method: 'GET' }
        );
    }
    static PostV2FeedbackDetails(
        this: void,
        req: V2PostTeacherFeedbackDetailsRequest,
        initReq?: fm.InitReq
    ): Promise<GoogleProtobufEmpty.Empty> {
        return fm.fetchRequest<GoogleProtobufEmpty.Empty>(
            `/v2/feedback/sessions/${req.sessionId}/details`,
            { ...initReq, method: 'POST', body: JSON.stringify(req, fm.replacer) }
        );
    }
    static GetTeacherFeedbackV2WithFilter(
        this: void,
        req: GetTeacherFeedbackV2WithFilterRequest,
        initReq?: fm.InitReq
    ): Promise<GetTeacherFeedbackV2WithFilterResponse> {
        return fm.fetchRequest<GetTeacherFeedbackV2WithFilterResponse>(
            `/v2/feedback/filter?${fm.renderURLSearchParams(req, [])}`,
            { ...initReq, method: 'GET' }
        );
    }
    static GetMathLevels(
        this: void,
        req: GoogleProtobufEmpty.Empty,
        initReq?: fm.InitReq
    ): Promise<MathLevelsResponse> {
        return fm.fetchRequest<MathLevelsResponse>(
            `/v2/feedback/math-levels?${fm.renderURLSearchParams(req, [])}`,
            { ...initReq, method: 'GET' }
        );
    }
}
